import React from "react";
import { Field, BaseProps } from "./field";
import { Input, InputAdornment } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";

type Props = BaseProps<string> & {
  placeholder?: string;
};

export const Searchbox: React.FC<Props> = (props) => {
  function onChange(event: React.ChangeEvent<HTMLInputElement>): void {
    if (props.onChange) {
      props.onChange(props.name, event.target.value);
    }
  }

  return (
    <Field
      label={props.label}
      required={props.required}
      error={props.error}
      disabled={props.disabled}
      size={props.size}
    >
      <Input
        disabled={props.disabled}
        error={!!props.error}
        name={props.name}
        onChange={onChange}
        placeholder={props.placeholder || ""}
        required={props.required}
        endAdornment={
          <InputAdornment position="end">
            <SearchIcon fontSize="small" color="disabled" />
          </InputAdornment>
        }
        value={props.value || ""}
        type="text"
      />
    </Field>
  );
};
